import { createFileRoute } from '@tanstack/react-router';
import { redirectToHealthReadiness } from '@/components/health-readiness/legacy-redirect';

/** The old Go-Live Readiness → Trend (T-0224, T-0242): the Snapshots & trend tab. */
export const Route = createFileRoute('/engagements/$engagementId/golive/trend')({
  beforeLoad: ({ params }) => {
    throw redirectToHealthReadiness(params.engagementId, { tab: 'snapshots' });
  },
});
